
export class Setting<T> {
  private _value: T

  constructor(private name: string, defaultValue: T) {
    const value = localStorage.getItem(name);
    if (!!value && typeof defaultValue === 'string')
      this._value = value as unknown as T
    else if(!!value)
      this._value = JSON.parse(value)
    else
      this._value = defaultValue
  }

  get(){
    return this._value
  }

  set(value: T) {
    this._value = value
    localStorage.setItem(this.name, JSON.stringify(this._value))
  }
}